<template>
  <div v-if="!route.hidden" class="sidebar-item-container">
    <template v-if="hasOneShowingChild(route.children, route) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !route.alwaysShow">
      <app-link
        :to="resolvePath(onlyOneChild.path)"
        :disabled="onlyOneChild.disabled || isUnlock(resolvePath(onlyOneChild.path))"
        @click.native="linkClick(onlyOneChild)"
      >
        <item
          @click.native="clickItem(isUnlock(resolvePath(onlyOneChild.path)), onlyOneChild)"
          :isLock="isUnlock(resolvePath(onlyOneChild.path))"
          class="item-link"
          :icon="onlyOneChild.meta.icon  || (route.meta && route.meta.icon)"
          :title="onlyOneChild.meta.title"
          :is-active="activePath === resolvePath(onlyOneChild.path)"
          :tag="onlyOneChild.meta.tag"
          :meta="onlyOneChild.meta"
        />
      </app-link>
    </template>
    
    <sub-menu v-else :route="route" :is-unfold="isUnfold" :base-path="resolvePath(route.path)" :active-path="activePath">
      <div v-if="isUnfold" class="nest-menu-container" @click.stop>
        <sidebar-item
          v-for="child in route.children"
          :key="child.path"
          :route="child"
          :base-path="resolvePath(child.path)"
          :active-path="activePath"
          :is-unfold="isUnfold"
          class="nest-menu"
        />
      </div>
    </sub-menu>
  </div>
</template>
<script>
import path from 'path'
import { isExternal } from '@/tools/basic-methods'
import AppLink from './link'
import Item from './item.vue'
import SubMenu from './sub-menu.vue'
import { mapState, mapGetters } from 'vuex'
import matchWhitelist from "@/router-v2/whitelist";
import matchFreemiumUnlocklistlist from "@/router-v2/freemium-unlock-router";
export default {
  name: 'SidebarItem',
  components: { AppLink, Item, SubMenu },
  props: {
    route: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    },
    activePath: {
      type: String,
      default: ''
    },
    isUnfold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  computed: {
    ...mapState({
      expiredTrialAccount: (state) => state.user.expiredTrialAccount,
      demoType: (state) => state.user.demoType,
      usersAuthorities: (state) => state.user.usersAuthorities
    }),
    ...mapGetters('user', [
      'userId'
    ]),
    isUnlock() {
      return (path) => {
        if (this.userId === null) {
          if (!matchWhitelist(path)) {
            return true
          }
        }
        if (this.demoType == 'freemium') {
          if (matchFreemiumUnlocklistlist(path)) {
            return true
          }
        }
        return false
      }
    },
  },
  methods: {
    clickItem(data, pathInfo) {
      console.log(pathInfo, data, 'pathInfo')
      let name = pathInfo.name
      if (pathInfo.name =='Edit Report') {
        name = 'iftaEditReport'
      }
      // NOTICE: Add a new param 'interceptOverlay' in meta to intercept the overlay page
      const interceptOverlay = pathInfo.meta && pathInfo.meta.interceptOverlay
      if (data && interceptOverlay) {
        return this.$router.push({
          path: interceptOverlay
        })
      }
      if (data && name) {
        this.$router.push({
          // path: `/intercept/index/${pathInfo.name}`
          path: `/intercept/${name}`
        })
      }
    },
    linkClick(data = {}) {
      const name = data.name || ''
      switch (name) {
        case "map":
          this.$buriedPoints(2)
          break
        case "dispatchLoads":
          this.$buriedPoints(3)
          break
        case "document":
          this.$buriedPoints(4)
          break
        case "Trucks":
          this.$buriedPoints(5.1)
          break
        case "Trailers":
          this.$buriedPoints(5.2)
          break
        case "basicInfo":
          this.$buriedPoints(6.1)
          break
        case "Tools":
          this.$buriedPoints(6.2)
          break
        case "searchLoads":
          this.$buriedPoints(8.1)
          break
        case "dashboard":
          this.$buriedPoints(1.4)
          break
        case "schedule":
          this.$buriedPoints(10.17)
          break
        case "Integration":
          this.$buriedPoints(10.2)
          break
        case "drivers":
          this.$buriedPoints(10.25)
          break
        case "driverSettlement":
          this.$buriedPoints(10.5)
          break
        case "message":
          this.$buriedPoints(10.6)
          break
        case "expense":
          this.$buriedPoints(11)
          break
        case "Invoice":
          this.$buriedPoints(14.1)
          break
        case "Dashboard":
          this.$buriedPoints(23.01)
          break
      }
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // 如果只有一个子路由时使用
          this.onlyOneChild = item
          return true
        }
      })

      // 当只有一个子路由时，默认显示子路由
      if (showingChildren.length === 1) {
        return true
      }

      // 如果没有要显示的子路由，则显示父级
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      if (this.demoType == 'freemium' && ['/accounting'].includes(parent.path)) {
        this.onlyOneChild = { ...parent, noShowingChildren: true , }
        return true
      }

      let noLoginHiddenChildrenList = ['/dispatch', '/assets', '/accounting', '/maintenance']
      if (!this.userId && noLoginHiddenChildrenList.includes(parent.path)) {
        this.onlyOneChild = { ...parent, noShowingChildren: true , }
        return true
      }


      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      // if (isExternal(this.basePath)) {
      //   return this.basePath
      // }
      return path.resolve(this.basePath, routePath)
    },
  }
}
</script>
<style lang="scss" scoped>
.sidebar-item-container {
  padding: 0 12px;
  font-size: 14px;

  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-decoration: none;
    vertical-align: top;
  }
  .nest-menu-container {
    .sidebar-item-container {
      padding: 0;
    }
  }
}
</style>
 